<template>
	<div v-if="brands.length > 0" class="tickFilters brandsFilter">
		<div class="linkWrapper filter">
			<span class="titleItem" @click="open=!open">By Brand</span>
			<span 
				class="hasChildren"
				:class="open ? 'showChildren' : ''"
				@click="open=!open"
			>
			</span>
		</div>
		<ul 
			ref="subList"
			:style="'max-height: ' + maxHeight + 'px;'"
			class="subcategoryList"
		>
			<TickFilter
				v-for="brand in brands"
				:key="brand.id"
				:onclick="() => {setBrandFilter(brand.id)}"
				:ticked="selectedBrands.includes(brand.id)"
			>
				{{brand.name}}
			</TickFilter>
		</ul>
	</div>
</template>

<script>
import TickFilter from "@/components/filters/tickFilter";

export default {
	name: "BrandsFilter",
	props: ["allProducts", "brandsData"],
	data(){
		return {
			open: false,
		}
	},
	components: {
		TickFilter
	},
	mounted() {
		if("subList" in this.$refs) {
			for (let child of this.$refs.subList.children){
				this.height += child.offsetHeight;
			}
		}
	},
	computed: {
		brands() {
			if (!this.brandsData || !this.allProducts) return [];
			return this.brandsData
				.map(({ title, brand_id_fk }) => { 
					return {
						name: title,
						id: brand_id_fk
					}
				})
				.concat(
					this.allProducts.map(({ brand, brand_id_fk }) => {
						return {
							name: brand,
							id: brand_id_fk
						} 
					})
				)
				.reduce((unique, item) => {
					for (let element of unique) {
						if (element.id == item.id) {
							return unique
						}
					}
					return [...unique, item]
				}, [])
				.sort((a, b) => a.name.localeCompare(b.name));
		},
		selectedBrands() {
			if (this.$route.query.brand) {
				return this.$route.query.brand.split(",");
			} else {
				return [];
			}
		},
		height() {
			let height = 0;
			if("subList" in this.$refs) {
				for (let child of this.$refs.subList.children){
					height += child.offsetHeight;
				}
			}
			return height;
		},
		maxHeight() {
			if (this.open) {
				return this.height;
			} else {
				return 0;
			}
		}
	},
	methods: {
		//add filter to list, remove if already in list
		setBrandFilter(brandId) {
		//get existing brands query
		let newQuery;
		if (this.$route.query.brand) {
			newQuery = this.$route.query.brand.split(",");
		} else {
			newQuery = [];
		}

		//remove brand id if already in list
		if (newQuery.includes(brandId)) {
			newQuery = newQuery.filter(item => item != brandId);
		} else {
			newQuery.push(brandId);
		}

		if (newQuery.length === 0) {
			//remove if filter already set is clicked
			this.$router.push({
			query: { ...this.$route.query, brand: undefined }
			});
		} else {
			this.$router.push({
			query: { ...this.$route.query, brand: newQuery.join(",") }
			});
		}
		}
	}
};
</script>

<style lang="scss" scoped>
	.current {
		background: red;
	}

	.rightArrow {
		display: inline-block;
		font-size: 0.5em;
		padding-bottom: 1px;
		vertical-align: middle;
	}
</style>
